<template>
  <div class="container">
    <div class="header">
      <div class="nav">
        <ul>
          <router-link to="/home"><li>首页</li></router-link>
          <router-link to="/about"><li>关于心动好物</li></router-link>
          <router-link to="/contact"><li>联系我们</li></router-link>
          <router-link to="/charge"><li class="navLi">收费资讯</li></router-link>
          <registerModule></registerModule>
        </ul>
      </div>
      <div class="peopleIntro">
        <!--          <img src="@/assets/img/peopleIntro.png" alt="">-->
      </div>
    </div>
    <div class="center">
      <p class="centerTitle">收费资讯</p>
      <p class="subTitle">付费0.5元即可阅读全文</p>
      <div class="centerContent">
        <div class="content">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span class="subject">工作如何做总结(一)</span>
            </div>
            <p class="mainBody">由于平时较多的工作加以延误，产生了“学不学不是很重要，做到工作才重要的以干代学的思想，没有把学习摆到重要的位置，缺乏持之以恒的学习精神。欠缺学习知识的广度和深度,平时的学习中,只注重看些...</p>
<!--            @mouseover="openApp(1)" @mouseout="openApp(2)"-->
            <div @click="openShow(1)" class="buyButton"><p>付费0.5元查看</p><p>2022-10-05</p></div>
            <div v-show="dialog == 1" class='popContainer' @click="hideDialog">
              <img ref="IOSImg" class="IOSImg onePosition" src="@/assets/img/erweima.jpg" alt="">
            </div>
          </el-card>
<!--           <p class="subject">工作如何做总结(一)</p>-->
<!--           <span class="mainBody">  由于平时较多的工作加以延误，产生了“学不学不是很重要，做到工作才重要的以干代学的思想，没有把学习摆到重要的位置，缺乏持之以恒的学习精神。欠缺学习知识的广度和深度,平时的学习中,只注重看些...</span>-->
<!--           <div @click="openShow" class="buyButton"><p>付费0.5元查看</p><p>2022-10-05</p></div>-->
        </div>
        <div class="content">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span class="subject">带不好团队的6大原因</span>
            </div>
            <p class="mainBody">被平庸的员工绑架 管理者不敢或不忍对没有完成任务的员工惩罚或开除，导致优秀员工感觉做好做坏都一样 不懂设优化系统和做好流程 企业管理的核心是改变流程或者优化系统，不是迫使个别人做得更好...</p>
            <div @click="openShow(2)" class="buyButton"><p>付费0.5元查看</p><p>2022-10-10</p></div>
            <div v-show="dialog == 2" class='popContainer' @click="hideDialog">
              <img ref="IOSImg" class="IOSImg onePosition" src="@/assets/img/erweima.jpg" alt="">
            </div>
          </el-card>
<!--          <p class="subject">带不好团队的6大原因</p>-->
<!--          <span class="mainBody">  被平庸的员工绑架 管理者不敢或不忍对没有完成任务的员工惩罚或开除，导致优秀员工感觉做好做坏都一样 不懂设优化系统和做好流程-->
<!--企业管理的核心是改变流程或者优化系统，不是迫使个别人做得更好...</span>-->
<!--          <div @click="openShow" class="buyButton"><p>付费0.5元查看</p><p>2022-10-10</p></div>-->
        </div>
        <div class="content">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span class="subject">做管理顺序不要搞反了</span>
            </div>
            <p class="mainBody">激励第一，考核第二:没有激励，谁愿意被考核;结果第一，目标第二:没有结果，目标都是想法;态度第一，能力第二:知道为什么做，能力才会充分释放;产值第一，价值第二:真正的价值是做出高的产出...</p>
            <div @click="openShow(3)" class="buyButton"><p>付费0.5元查看</p><p>2022-10-10</p></div>
            <div v-show="dialog == 3" class='popContainer' @click="hideDialog">
              <img ref="IOSImg" class="IOSImg onePosition" src="@/assets/img/erweima.jpg" alt="">
            </div>
          </el-card>
<!--          <p class="subject">做管理顺序不要搞反了</p>-->
<!--          <span class="mainBody"> 激励第一，考核第二:没有激励，谁愿意被考核;结果第一，目标第二:没有结果，目标都是想法;态度第一，能力第二:知道为什么做，能力才会充分释放;产值第一，价值第二:真正的价值是做出高的产出...</span>-->
<!--          <div @click="openShow" class="buyButton"><p>付费0.5元查看</p><p>2022-10-31</p></div>-->
        </div>
        <div class="content">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span class="subject">工作如何做总结(二)</span>
            </div>
            <p class="mainBody">工作方面:对待工作不够主动、积极，只满足于完成领导交给的任务，在工作中遇到难题，不善于思考，常常等待领导的指示，说一步走一步。缺乏一种敬业精神，认为自己已有的一些业务知识可以适应目前的工作了...</p>
            <div @click="openShow(4)" class="buyButton"><p>付费0.5元查看</p><p>2022-10-10</p></div>
            <div v-show="dialog == 4" class='popContainer' @click="hideDialog">
              <img ref="IOSImg" class="IOSImg onePosition" src="@/assets/img/erweima.jpg" alt="">
            </div>
          </el-card>
<!--          <p class="subject">工作如何做总结(二)</p>-->
<!--          <span class="mainBody">  工作方面:对待工作不够主动、积极，只满足于完成领导交给的任务，在工作中遇到难题，不善于思考，常常等待领导的指示，说一步走一步。缺乏一种敬业精神，认为自己已有的一些业务知识可以适应目前的工作了...</span>-->
<!--          <div @click="openShow" class="buyButton"><p>付费0.5元查看</p><p>2022-11-05</p></div>-->
        </div>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
  import bottom from '@/components/bottom.vue'
  import registerModule from "@/components/registerModule.vue";

  export default {
    name: "charge",
    components:{bottom, registerModule},
    data() {
      return {
        dialog:0
      }
    },
    methods: {
      openShow(v) {
        // if(window.confirm('该文章需要付费0.5元阅读全文，确定付费?')){
        //   this.$router.push('/blank')
        // }
        if(v == 1){
          this.dialog = 1;
        }else if(v == 2){
          this.dialog = 2;
        }else if(v == 3){
          this.dialog = 3;
        }else if(v == 4){
          this.dialog = 4;
        }
      },
      // openApp(val) {
      //   if(val === 1){
      //     // this.$refs.IOSImg.style.display = 'block';
      //     this.dialog = 1;
      //   }else if(val === 2){
      //     // this.$refs.IOSImg.style.display = 'none';
      //     this.dialog = 0;
      //   }
      // },
      hideDialog(){
        this.dialog = 0
      }
    },
  }
</script>

<style scoped>
.header{
  height:910px;
  background:url(../../assets/img/about1920-910.png) no-repeat center center;
  background-size:100% 100%;
  padding-top:25px;
  position:relative;
}
/*.nav{*/
/*  height:65px;*/
/*  margin-right:323px;*/
/*}*/
.nav{
  width:100%;
  height:150px;
  border: 0px solid red;
  margin:0 auto;
  background:url(../../assets/img/logoLine.png) no-repeat 230px 70px;
  background-size:268px 54px;
  padding-right:323px;
}
.nav ul{
  height:70px;
  display:flex;
  justify-content:flex-end;
  align-items:center;
}
.nav ul li{
  font-size:18px;
  color:#221815;
  font-weight:600;
  padding:13px 35px;
  margin-right:20px;
  font-family:'PingFang Bold';
}
.navLi{
  border:1px solid rgba(34, 24, 21, 0.5);
  border-radius:20px;
}
.peopleIntro{
  position:absolute;
  left:382px;
  top:300px;
}
.peopleIntro img{
  width:642px;
  height:355px;
}
.intro{
  margin-top:90px;
  margin-bottom:86px;
  display:flex;
  justify-content:center;
  align-items:center;
}
.lastIntro{
  margin-bottom:165px;
}
.imgIntro{
  width:541px;
  margin-right:60px;
}
.imgIntro:last-child{
  margin-right:5px;
}
.aboutOur, .mission, .vision, .slogan{
  width:80px;
  height:80px;
}
.aboutOur img{
  width:70px;
  height:68px;
}
.mission img{
  width:63px;
  height:71px;
}
.vision img{
  width:66px;
  height:72px;
}
.slogan img{
  width:68px;
  height:60px;
}
.imgTitle{
  margin:16px 0 44px 0;
  font-family: 'PingFang Bold';
  font-size:28px;
  color:#3B3D40;
}
.imgContent{
  font-family: 'PingFang Light';
  font-weight:600;
  font-size:24px;
  color:#656B6F;
  letter-spacing:2px;
  line-height:35px;
}
.course{
  height:350px;
  display:flex;
  justify-content:center;
  align-items:center;
  background-color: #FAFCFE;
  background-size:100% 340px;
}
.course2{
  width:100%;
  /*height:755px;*/
  margin-bottom:120px;
  display:flex;
  justify-content:center;
  align-items:center;
}
.item{
  width:384px;
  height:285px;
  margin-top:6px;
  margin-right:35px;
  -webkit-border-radius:2px;
  -moz-border-radius:2px;
  border-radius:2px;
}
.course2 .item{
  margin-top:0px;
}
.item:hover{
  -moz-box-shadow:0px 4px 4px rgba(199, 227, 230, 0.35);
  -webkit-box-shadow:0px 4px 4px rgba(199, 227, 230, 0.35);
  box-shadow:0px 4px 4px rgba(199, 227, 230, 0.35);
}
.item:last-child{
  margin-right:0px;
}
.item img{
  width:384px;
  height:285px;
}
.itemContent{
  margin-top:44px;
  font-family: 'PingFang Light';
  font-weight:600;
  font-size:24px;
  color:#656B6F;
  letter-spacing:1px;
  line-height:34px;
  padding:11px 15px 0 14px;
}
.center{
  padding-bottom: 100px;
}
.centerTitle{
  text-align: center;
  font-weight: normal;
  font-size: 40px;
  text-transform: uppercase;
  font-family: "Verdana", "sans-serif";
  color: #828282;
  padding-top: 20px;
  margin-bottom: 20px;
}
.subTitle{
  text-align: center;
  color: #000;
  font-size:25px;
  font-weight: normal;
  margin-bottom: 60px;
}
.centerContent{
  display: flex;
  justify-content: space-between;
  /*background: cyan;*/
  padding:0 319px 0 350px;
}
.content{
  width: 270px;
  /*height: 300px;*/
  /*background: orange;*/
}
.subject{
  font-weight: normal;
  /*color: #666;*/
  font-size: 20px;
  /*margin-bottom: 20px;*/
}
.mainBody{
  /*color: #828282;*/
  font-size:18px;
  line-height: 26px;
  cursor: pointer;
}
.buyButton{
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  position: relative;
}
.buyButton p:nth-child(1){
  color: #989898;
  text-align: center;
  border: 1px solid #e3e3e3;
  padding:10px;
  cursor: pointer;
}
.buyButton p:nth-child(2){
  color: #989898;
  text-align: right;
  font-style: italic;
  position: absolute;
  right: 0;
  bottom: 10px;
}

.box-card{
  width: 300px;
  height: 340px;
  position: relative;
}
.IOSImg{
  width:150px;
  height:150px;
  /*position:absolute;*/
  /*left:75px;*/
  /*bottom:75px;*/
  /*display:none;*/
}

.onePosition{
  position: absolute;
  top: 45%;
  left: 50%;
  transform:translate(-50%,-50%);
}

.popContainer{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.3);
  z-index:10
}
</style>



// WEBPACK FOOTER //
// src/pages/charge/charge.vue